import { FC, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { SocketContext, TeamContext } from "../../../../context";
import { MainButton } from "../../../atoms";

interface IJoinNewPlayer {
    urlTokenExtracted: string;
    loginData: any;
    isDisabled: boolean;
}

const JoinNewPlayer: FC<IJoinNewPlayer> = ({ urlTokenExtracted, loginData, isDisabled }) => {
	const { t } = useTranslation();
    const { socket } = useContext(SocketContext);
    const { game } = useContext(TeamContext);
    let history = useHistory();

    
    const joinNewPlayer = () => {

		let payload = {
			matchId: urlTokenExtracted,
			gameId: 1,
			player: {
				email: loginData?.email,
				fullName: loginData?.fullName,
				nickname: loginData?.nickname
			}
		};
		localStorage.setItem("userEmailInCaseHeLogsOut", loginData?.email);

		socket?.emit("joinPreLobby", payload);
		history.push(`/slotmachineDemo/${urlTokenExtracted}`);
	}

    return <MainButton text={t("joinAsANewPlayerText")} type="big" clickHandler={() => joinNewPlayer()} disabled={isDisabled} />
}

export default JoinNewPlayer;